<div class="col full-height layout-column">

  <app-planning-draft-routes-panel-list-item [route]="route"
                                             [logisticsVehicleName]="logisticsVehicleName"
                                             [jobs]="jobs"
                                             [settings]="settings.routes"
                                             [isVisible]="visibleKeys[route.id]"
                                             [canClose]="true"
                                             [itemElementSize]="itemElementSize"
                                             [isShowActionMenu]="true"
                                             (onDispatch)="onDispatch.emit($event)"
                                             (onPrint)="onPrint.emit($event)"
                                             (onDelete)="onDelete.emit($event)"
                                             (onClose)="onSelect.emit()"
                                             (onPrintLoadingSheet)="onPrintLoadingSheet.emit($event)"
                                             (onReoptimize)="onReoptimize.emit($event)"
                                             (onLockRouteChange)="onLockRouteChange.emit($event)"
                                             (onPreAssignAgent)="onPreAssignAgent.emit($event)"
                                             (onToggleVisible)="onToggleVisibleRoute(route.id, $event)"
                                             (onEditResourceAllocation)="onEditResourceAllocation.emit($event)"
                                             (onFeedback)="onFeedback.emit($event)"
                                             (onChangeRouteResource)="onChangeRouteResource.emit($event)">

  </app-planning-draft-routes-panel-list-item>

  <div class="flex layout-column dndList overflow-auto margin-top-5"
       cdkDropList
       [cdkDropListData]="route.activities"
       id="{{panel.id}}"
       [cdkDropListConnectedTo]="connectedPanelIds"
       [cdkDropListDisabled]="!!isLoading || route.locked || isRunning || route.status === 'DISPATCHED'"
       [cdkDropListSortPredicate]="sortPredicate"
       (cdkDropListEntered)="enter($event)"
       (cdkDropListDropped)="drop($event)">

    <div class="layout-column gap-10" *ngFor="let activity of route.activities;let index = index"
         [style.display]="tripTotalsMap[activity.tripNumber] && !tripTotalsMap[activity.tripNumber].isExpanded && (tripTotalsMap[activity.tripNumber].firstActivityId !== activity.id) ? 'none' : ''">

      <div
        *ngIf="tripTotalsMap[activity.tripNumber] && (tripTotalsMap[activity.tripNumber].firstActivityId === activity.id) && isDisplayRetrips"
        class="retrip-item layout-row layout-align-start-center gap-10">

        <div class="trip-number"
             [style.border-color]="routeColor"
             [style.background]="routeColor + 20"
             [style.color]="routeColor">
          <span>Retrip {{ tripTotalsMap[activity.tripNumber].tripNumber }}</span>
        </div>


        <div class="layout-row layout-align-start-center gap-5">
          <bringoz-icon iconName="weight"
                        classSize="lg"
                        fill="#484848"
                        [ngbTooltip]="'Weight' | translate"
                        openDelay="300">

          </bringoz-icon>
          <span
            class="br-body-2">{{ tripTotalsMap[activity.tripNumber].packages | planningPackagesWeightPipe:false: true }}</span>
        </div>

        <div class="layout-row layout-align-start-center gap-5">
          <bringoz-icon iconName="volume"
                        classSize="md"
                        fill="#484848"

                        [ngbTooltip]="'Volume' | translate"
                        openDelay="300">

          </bringoz-icon>
          <span
            class="br-body-2">{{ tripTotalsMap[activity.tripNumber].packages | planningPackagesVolumePipe: true }}</span>

        </div>

        <span *ngIf="tripTotalsMap[activity.tripNumber].Pickup" class="br-body-2 pickup-color">{{tripTotalsMap[activity.tripNumber].Pickup | number}}{{ 'STOP_PURPOSE.P' | translate }}</span>
        <span *ngIf="tripTotalsMap[activity.tripNumber].Dropoff" class="br-body-2 dropoff-color">{{tripTotalsMap[activity.tripNumber].Dropoff | number}}{{ 'STOP_PURPOSE.D' | translate }}</span>
        <span *ngIf="tripTotalsMap[activity.tripNumber].Operation" class="br-body-2 operation-color">{{tripTotalsMap[activity.tripNumber].Operation | number}}{{ 'STOP_PURPOSE.O' | translate }}</span>

        <span class="flex"></span>
        <app-expand-button class="margin-right-5"
                           [isExpanded]="tripTotalsMap[activity.tripNumber].isExpanded"
                           (onToggle)="tripTotalsMap[activity.tripNumber].isExpanded = !tripTotalsMap[activity.tripNumber].isExpanded">
        </app-expand-button>
      </div>

      <app-planning-draft-route-panel-activity-item
        [style.display]="tripTotalsMap[activity.tripNumber] && !tripTotalsMap[activity.tripNumber].isExpanded ? 'none' : ''"
        class="flex"
        [activity]="activity"
        [index]="index"
        [job]="jobsMap[activity.jobId]"
        [jobs]="activityJobsMap[activity.id]"
        [route]="route"
        [settings]="settings.route"
        [highlightedActivity]="highlightedActivity"
        [itemElementSize]="itemElementSize"
        [isSmallScreen]="isSmallScreen"
        [isSelected]="selectedKeys[activity.id]"
        [isDisplayRetrips]="isDisplayRetrips"
        [queryText]="queryText"
        (onViewJob)="onViewJob.emit($event)"
        [isActivityLocked]="isActivityLocked(activity)"
        (onToggleObligateTimeWindow)="onToggleObligateTimeWindow.emit({jobIds: $event.jobIds, obligateTimeWindow: $event.obligateTimeWindow})"
        (onToggleLockJobs)="onToggleLockJobs.emit($event)"
        (onToggle)="onSelectedChange(activity, $event)"
        cdkDrag
        [cdkDragDisabled]="(activity.type === 'START' || activity.type === 'END') || (!!isLoading || route.locked || isRunning || route.status === 'DISPATCHED')"
        [cdkDragData]="activity"
      >

        <div cdkDragHandle appBringozIdGenerator="drag-task-route-drill-down">
          <bringoz-icon iconName="drag" class="secondary-100"></bringoz-icon>
        </div>

        <div *ngIf="isMultipleActivitiesDragged(activity.jobIds || [activity.jobId])">
          <div *cdkDragPreview id="app-planning-draft-route-panel-view-test-preview-drag-multiple-activities-container">
            {{ 'DRAGGING_X_ITEMS.JOBS' | translate:{X: selectedJobIds.length} }}
          </div>
        </div>

      </app-planning-draft-route-panel-activity-item>
    </div>

    <ng-template cdkDropListPlaceholder>
      <div class="placeholder">Drop here</div>
    </ng-template>

  </div>

  <app-bringoz-linear-progress *ngIf="!!isLoading || isRunning"></app-bringoz-linear-progress>
</div>
